import WithDirection from '@app/settings/withDirection';
import { Button } from 'antd';
import { Buttons, ButtonsGroup } from './styles/button.style';

const AntButton = Buttons(Button);
const AntButtonGroup = ButtonsGroup(Button.Group);

export const IsoButton = WithDirection(AntButton);
export const IsoButtonGroup = WithDirection(AntButtonGroup);
